import { Yup } from 'shared/lib'

const schema = Yup.object().shape({
   loginParameter: Yup.string(),
   passwordParameter: Yup.string(),
   additionalParameter: Yup.string(),
   firstDepartment: Yup.string(),
   secondDepartment: Yup.string(),
   thirdDepartment: Yup.string(),
   currency: Yup.string().oneOf(['EUR', 'PLN', 'CZK']),
   status: Yup.string().oneOf(['NEW', 'PERMANENT', 'INACTIVE']),
   deliveryDepartment: Yup.string().required(),
   logisticMinimums: Yup.number(),
   priceVariant: Yup.string(),
   conditions: Yup.string(),
})

export default schema
